import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import mlBaseSelector from '@store/metricLens/base/selectors';
import * as sharingActions from '@store/metricLens/sharing/actions';
import { sharingIsFetchingSelector } from '@store/metricLens/sharing/selectors';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { PAGE_TYPE } from '@utils/constants';
import sharing from '../../common/sharing';
import MLDashboard from '../MetricLensDashboard';
import injectorServer from '../../common/injectorServer';

const mlPageSelector = createSelector(
  mlBaseSelector,
  tabsStoreSelector,
  sharingIsFetchingSelector,
  (mlBase, tabsStore, fetching) => ({
    isFetching: fetching,
    isSharing: true,
    mlBase,
    tabs: tabsStore,
  }),
);

const MLSharingDashboard = connect(mlPageSelector, {
  init: sharingActions.initRequest,
  getSharing: sharingActions.getSharing,
  pageType: PAGE_TYPE.SHARING,
})(sharing()(MLDashboard));

export default injectorServer({}, { pageType: PAGE_TYPE.SHARING })(MLSharingDashboard);
